export const themeB = {
  name: "深夜藝廊",
  colors: {
    bg: "#1A1916",
    bgSecondary: "#22201C",
    text: "#F0EBE3",
    textSecondary: "#9A9488",
    textMuted: "#959087",
    accent: "#E8A0BF",
    accentText: "#1A1916",
    accentAlt: "#7BB5CF",
    accentWarm: "#F0D58C",
    accentOrange: "#E8A672",
    available: "#7BAF6E",
    availableText: "#1A1916",
    claimed: "#4A4640",
    cardBg: "#242220",
    cardBorder: "#333028",
    overlay: "rgba(26,25,22,0.7)",
    heroBg: "#1A1916",
    heroText: "#F0EBE3",
  },
  fonts: {
    heading: "'Zen Maru Gothic', 'Noto Sans TC', sans-serif",
    body: "'Noto Sans TC', sans-serif",
    accent: "'Caveat', cursive",
  },
  fontUrls: ["https://fonts.googleapis.com/css2?family=Caveat&display=swap"],
  radius: { sm: "10px", md: "16px", lg: "24px", full: "9999px" },
  spacing: { cardGap: "20px", sectionGap: "48px", pagePadding: "20px" },
  effects: {
    cardShadow: "0 2px 16px rgba(0,0,0,0.3)",
    cardHoverShadow: "0 4px 24px rgba(0,0,0,0.5)",
    bgTexture: true,
    textureOpacity: 0.02,
  },
};
